import styled from 'styled-components';

// What each tab of the site select modal asks
export const Question = styled.p`
    margin: 0;
    font-family: var(--text_heading_font);
    letter-spacing: var(--text_heading_font_spacing);
    color: var(--text_subheading_color);
    font-weight: bold;
`;

export const ErrorMessage = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    color: var(--invalid);

    .material-symbols-outlined {
        font-size: 24px;
        line-height: 24px;
    }
`;
